import React from 'react';
import {injectIntl} from 'react-intl';
import {formatCurrency} from '../../../utils/formatters';

export function CardPriceComponent({intl, price}) {
    if (price) {
        const {currency, value} = price;
        const {formatMessage, formatNumber} = intl;
        const valueAsCurrency = formatCurrency(formatNumber, value, currency);
        const perNight = formatMessage({id: 'listings.avgNight'});
        const priceText = `${valueAsCurrency} ${perNight}`;

        return <span className="great-place__card__price">{priceText}</span>;
    }
    return null;
}

export default injectIntl(CardPriceComponent);
